import "maplibre-gl/dist/maplibre-gl.css";
import "./styles/main.css";
import { App } from "./app/App";

const root = document.querySelector<HTMLElement>("#app");
if (!root) throw new Error("App root element was not found.");

new App().mount(root);
